import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Ciudad } from "@/shared/types/ciudad";

export async function getCiudad(id: string): Promise<Ciudad> {
    await sleep(1000);
    const response = await api.get("ciudades/" + id);
    return response.data;
}

export function useGetCiudadQuery(id: string, queryConfig: QueryConfig<Ciudad> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCiudad(id),
        queryKey: ["ciudades", id],
    });
}

export interface GetCiudadQueryProps {
    id: string;
    queryConfig?: QueryConfig<Ciudad>;
    children?: (queryResult: QueryResult<Ciudad>) => ReactNode;
}

export function GetCiudadQuery({
    id,
    queryConfig,
    children,
}: GetCiudadQueryProps) {
    const queryResult = useGetCiudadQuery(id, queryConfig);
    return children && children(queryResult);
}